import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const RejectionsReason = (props) => {
  const [reasons, setReasons] = useState({});

  const handleClose = () => {
    props.onHandleAddItem();
  };

  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_SECRET +
          "/api/RestaurantBankDetails/getCancelationDetailsByBankId/" +
          props.selectedData.id
      )
      .then((res) => {
        console.log(res.data);
        setReasons(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <Dialog
      fullWidth={true}
      open={props.open}
      onClose={handleClose}
      maxWidth={"sm"}
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Rejection Reason</Typography>
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent>
        <Grid container sx={{ padding: "0.5rem" }}>
          <Grid item xs={4}>
            <Typography>
              <strong>Rejection Reason:</strong>
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <p>{reasons?.reasonDescription}</p>
          </Grid>
        </Grid>
        <Grid container sx={{ padding: "0.5rem" }}>
          <Grid item xs={4}>
            <Typography>
              <strong>Description:</strong>
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <p>{reasons?.cancelationReasonDetails}</p>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default RejectionsReason;
